<span ultra-menu-item-wrapper>
	<button
		[iconClass]="'text-red-600'"
		[disabled]="!features.enableDeletes"
		ultra-menu-item
		(click)="onDelete()"
		content="shared|delete"
		svgIcon="delete"></button>
</span>
